import type { Product } from '@libs/common-types';

/**
 * True when any fulfillment path allows autoship purchase
 * (replaces legacy `Product.autoship.isEnabled`).
 */
export function isProductAvailableForAutoship(product: Pick<Product, 'deliveryMethods'>): boolean {
    const { STH, BOPIS, SDD } = product.deliveryMethods;
    return (
        Boolean(STH.availablePurchaseOptions?.autoship) ||
        Boolean(BOPIS.availablePurchaseOptions?.autoship) ||
        Boolean(SDD.availablePurchaseOptions?.autoship)
    );
}
